// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paging-container {
    display: flex;
    gap: .8rem;
}

.paging-tile {
    border: 2px solid #26a69a;
    padding: .5rem 1rem;
    background-color: rgba(240, 255, 255, 0.4);
    cursor: pointer;
    border-radius: 5px;
    user-select: none;
    appearance: none;
    outline: none;
    text-decoration: none;
}

    .paging-tile:hover {
        background-color: rgba(240, 255, 255, 0.65);
    }

    .paging-tile.selected-tile {
        background-color: rgba(240, 255, 255, 0.8);
        font-weight: bolder;
        border: 3px solid #26a69a;
        text-decoration: underline;
    }

    .paging-tile:focus {
        outline: none;
    }

        .paging-tile:focus:not(.selected-tile) {
            border: 2px solid #26a69a;
            background-color: rgba(240, 255, 255, 0.4);
            font-weight: inherit;
        }`, "",{"version":3,"sources":["webpack://./src/app/shared/components/paging/Paging.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,qBAAqB;AACzB;;IAEI;QACI,2CAA2C;IAC/C;;IAEA;QACI,0CAA0C;QAC1C,mBAAmB;QACnB,yBAAyB;QACzB,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;QAEI;YACI,yBAAyB;YACzB,0CAA0C;YAC1C,oBAAoB;QACxB","sourcesContent":[".paging-container {\r\n    display: flex;\r\n    gap: .8rem;\r\n}\r\n\r\n.paging-tile {\r\n    border: 2px solid #26a69a;\r\n    padding: .5rem 1rem;\r\n    background-color: rgba(240, 255, 255, 0.4);\r\n    cursor: pointer;\r\n    border-radius: 5px;\r\n    user-select: none;\r\n    appearance: none;\r\n    outline: none;\r\n    text-decoration: none;\r\n}\r\n\r\n    .paging-tile:hover {\r\n        background-color: rgba(240, 255, 255, 0.65);\r\n    }\r\n\r\n    .paging-tile.selected-tile {\r\n        background-color: rgba(240, 255, 255, 0.8);\r\n        font-weight: bolder;\r\n        border: 3px solid #26a69a;\r\n        text-decoration: underline;\r\n    }\r\n\r\n    .paging-tile:focus {\r\n        outline: none;\r\n    }\r\n\r\n        .paging-tile:focus:not(.selected-tile) {\r\n            border: 2px solid #26a69a;\r\n            background-color: rgba(240, 255, 255, 0.4);\r\n            font-weight: inherit;\r\n        }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
